<template>
  <!-- <div>
      <van-popup v-model="showDialog" round @close='close'>
          <div class="searchBox">
              <div v-for="(item,index) in searchData" :key="index" class="input">
                  <div>{{item.label}}</div>
                  <input type="text" v-model="queryInfo[[item.value]]">
              </div>
              <div class="btnBox">
                  <div @click="reset">重置</div>
                  <div @click="search">查询</div>
              </div>
          </div>
      </van-popup>

  </div> -->
    <div class="paidSearch">
    <van-popup v-model="showDialog" round @close="close">
      <div class="searchBox">
        <van-form class="search_form">
          <template v-for="(item, index) in queryFields">
          <van-field
            v-if="item.enable"
            label-align="right"
            v-model="queryInfo[item.fieldValue]"
            :label="item.fieldName"
            label-class="formLabel"
            :placeholder="'请输入' + item.fieldName"
          />
          </template>
          <!-- <van-field
            input-align="right"
            clearable
            v-model="queryInfo['paymentUnit']"
            label="缴款单位/人"
            placeholder="请输入单位或个人名称"
          />
          <van-field
            input-align="right"
            clearable
            v-model="queryInfo['idCard']"
            label="证件号码"
            placeholder="请输入证件号码"
          />
          <van-field
            input-align="right"
            clearable
            v-model="queryInfo['phone']"
            label="手机号码"
            placeholder="请输入手机号码"
          /> -->
        </van-form>

        <div class="btnBox">
          <van-button block @click="search" class="btn" type="info">
            查询
            <img
              class="blueSha"
              src="../../../assets/img/blueshadow.png"
              alt=""
            />
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {formatterDate,getNowFormatDate,handleTrim} from '@/utils/common.js'

export default {
    props:{
        showSearch:{
            type:Boolean
        },
        queryInfo:{
            type:Object
        },
        queryField:{
          type:Array,
          default:[]
        }
    },
    data() {
        return {
            showDialog:false,
            searchData:[
                {type:'input',label:'缴款单位/人',value:'paymentUnit'},
                {type:'input',label:'证件号码',value:'idCard'},
                {type:'input',label:'手机号码',value:'phone'},
            ],
            queryFields:[]
        }
    },
    created() {

    },
    watch:{
        showSearch(val) {
            this.showDialog = val;
            this.queryFields=this.queryField;
            console.log(val)
          }
    },
    methods:{
        search() {
            this.queryInfo.page = 1;
            this.$emit('searchPay',this.queryInfo);
        },
        reset() {
            this.queryInfo.paymentUnit = '';
            this.queryInfo.idCard = '';
            this.queryInfo.phone = '';
            this.search();
        },
        close() {
            this.showDialog = false;
            this.$emit('close')
        },
    }
}
</script>

<style lang='scss' scoped>
.paidSearch {
    ::v-deep .van-calendar__confirm{
        background: linear-gradient(-45deg, #54ADFB 0%, #297BF4 100%) !important;
        border: none;
        width: 305px;
        height: 44px;

        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 700;
        margin: 0 auto;
        margin-bottom: 10px;
    }
    ::v-deep .weekendRed {
        color: #ee0a24 !important;
    }
    ::v-deep .van-calendar__day--end{
        background: linear-gradient(-45deg, #54ADFB 0%, #297BF4 100%) !important;
        color: #fff !important;
    }
    ::v-deep .van-calendar__day--start{
        background: linear-gradient(-45deg, #54ADFB 0%, #297BF4 100%) !important;
        color: #fff !important;
    }
    ::v-deep .van-calendar__day--middle{
        color: rgb(45, 83, 235) !important;
    }

  ::v-deep .van-calendar__header-title{

    font-size: 18px;
    color: #464A4C;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-calendar__month-title {
    text-align: left;
    background: #f6f6f6 100%;

    font-size: 13px;
    color: #464A4C;
    letter-spacing: 0;
    font-weight: 500;
  }
}
.searchBox {
  .search_form{
    max-height: 60vh;
    overflow-y: auto;
  }
  // width: 300px;
  width: 343px;
  padding: 30px 20px 40px 20px;
  box-sizing: border-box;
  ::v-deep .van-cell::after {
    border-bottom: 1px solid #ebedf0 !important;
  }
  ::v-deep .van-cell__right-icon {
    line-height: 32px;
  }

  .van-field {
    ::v-deep &::after {
      border-bottom: none !important;
    }
    // box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
    // border-radius: 25px;
    height: 50px;
    line-height: 50px;
    background: #fff;

    border-bottom: 1px solid #ebedf0 !important;

    ::v-deep .van-cell__title {
      position: relative;
      top: -10px;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    ::v-deep .van-field__value {
      color: #333;
      position: relative;
      top: -10px;
    }
    ::v-deep .van-field__control {

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      text-align: right;
      font-weight: 500;
    }
    ::v-deep .van-field__control::-webkit-input-placeholder {

      font-size: 14px;
      color: #cccccc;
      letter-spacing: 0;
      font-weight: 400;
    }
    ::v-deep .van-field__label {
      width: auto;
    }
  }
  .btnBox {
    margin-top: 60px;
    ::v-deep .van-button--info {
      border: none !important;
      outline: none !important;
    }
    .btn {
      margin: 0 auto;
      width: 305px;
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
      border-radius: 22px;

      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      z-index: 15;
      position: relative;
      .blueSha {
        z-index: 10;
        width: 266px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
